import { render, staticRenderFns } from "./SearchRec.vue?vue&type=template&id=21f6c324&"
import script from "./SearchRec.vue?vue&type=script&lang=js&"
export * from "./SearchRec.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports